import React, {Component}       from 'react'
import { formatMoney }          from 'accounting'
import moment                   from 'moment'

import { Popconfirm, List, Skeleton, Button, Tooltip,
    Icon, Modal, message } from 'antd'

import SetFinanceAlert from './../set-finance-alert'
import CloudFlyerAPI      from "../../../api/CloudFlyerAPI"

import './styles.scss'

export default class FinanceAlerts extends Component {

    constructor(props){
        super(props)

        this.state = {
            loading : true,
            alerts  : []
        }
    }

    open = on_close => this.setState({visible:true, on_close}, this.refresh)

    on_cancel = () => this.setState({visible:false})

    refresh =()=>{
        this.setState({loading:true})
        CloudFlyerAPI
            .finance
            .alerts()
            .then(({data:alerts})=> this.setState({alerts, loading: false}))
            .catch(()=> this.setState({loading: false}, () => message.error('Failed to retrieve notifications.')))
    }

    on_delete_notification = id =>{
        console.log('on_delete_notification ' + id)
        CloudFlyerAPI
            .finance
            .delete_alert(id)
            .then(()=>{
                message.success('Alert deleted successfully.')
                this.refresh()
            })
            .catch(()=> message.error('Failed to delete alert.'))
    }

    on_close_set_alert =()=>{
        this.props.toggle_set_alert()
        this.refresh()
    }

    render() {
        const {
            alerts, loading,
            visible
        } = this.state

        return (
            <Modal
                className = 'modal-form finance-alerts'
                visible   = {visible}
                footer    = {null}
                onCancel  = {this.on_cancel}>

                <header>
                    Budget Alerting Email Notifications
                </header>

                <section className={'list-header'}>
                    <Tooltip title={'Add New Notification'} placement={'left'}>
                        <Button type="primary" shape="circle" icon="plus"
                                size={'small'} style={{'margin':'10px'}}
                                onClick={this.props.toggle_set_alert}/>
                    </Tooltip>
                </section>

                <Skeleton avatar title={false} loading={!alerts.length && loading} active>
                    {
                        alerts.length ?
                            <List
                                dataSource = {alerts}
                                renderItem = {item => (
                                    <List.Item key={item.id}
                                               actions={[
                                                   <Popconfirm title="Are you sure delete this alert?" key='Popconfirm' onConfirm={()=>this.on_delete_notification(item.id)} okText="Yes" cancelText="No">
                                                       {/*<a href="#">Delete</a>*/}
                                                       <Button href="#" type="primary" shape="circle" icon="stop" size={'small'}/>
                                                   </Popconfirm>,
                                               ]}>
                                        <List.Item.Meta
                                            avatar      = {<Icon type="bell"/>}
                                            title       = {<span>{`${item.title||''} ${item.product}`}</span>}
                                            description = {
                                                <span>
                                                    <span>{moment(item.start).format("MMM YY")}</span>
                                                    <span> - </span>
                                                    <span>{moment(item.end).format("MMM YY")}</span>
                                                </span>
                                            }/>
                                        <div>
                                            {item.actual_alert_percent &&
                                                [<span key='Actual'>Actual &nbsp;&nbsp;&nbsp;&nbsp;</span>,
                                                <span key='Actual value'>{item.actual_alert_percent}%</span>,
                                                <br key='br'/>]
                                            }
                                            {item.forecast_alert_percent &&
                                                [<span key='Forecast'>Forecast </span>,
                                                <span key='Forecast value'>{item.forecast_alert_percent}%</span>]
                                            }
                                        </div>
                                    </List.Item>
                                )}/>:<div>No notification found</div>
                    }
                </Skeleton>

                <SetFinanceAlert visible           = {this.props.set_alert_visible}
                                 selected_cloud    = {this.props.selected_cloud}
                                 selected_service  = {this.props.selected_service}
                                 tree              = {this.props.tree}
                                 on_service_change = {this.props.on_service_change}
                                 on_close          = {this.on_close_set_alert} />
            </Modal>
        )
    }
}